/*eslint-disable */
define(function(require) {
    var Backbone = require('backbone');
    var $        = require('jquery');
    var _        = require('underscore');
    var Mustache = require('mustache');

    return Backbone.View.extend({
        /**
         * UI element map.
         * The structure is { name: 'jquery selector', ... }
         * This map will be converted from jQuery selector to DOM node jQuery
         * instances once the View initializes.
         */
        ui: null,
        _cachedUI: null,

        /**
         * The ID of <script> tag containing the template to render.
         */
        templateId: null,

        /**
         * Override the _ensureElement so that we populate `ui` attribute
         * as soon as we have the DOM node.
         */
        _ensureElement: function() {
            Backbone.View.prototype._ensureElement.apply(this, arguments);

            if (this.ui) {
                this._populateUi();
            }
        },

        /**
         * Populates the `ui` map. Should be called manually if element is set
         * after the view was initialized.
         */
        _populateUi: function() {
            if (!this.ui) {
                return;
            }
            if (!this._cachedUI) {
                this._cachedUI = this.ui;
            }
            var map = this._cachedUI;
            // Change to a new variable to get the JS inheritance out of the way.
            this.ui = {};
            for (var key in map) {
                this.ui[key] = this.$( map[key] );
            }
        },

        /**
         * Return map of form field values in this view.
         *
         * @param Object options (optional)
         * > Boolean onlySubmittable: Don't return disabled values.
         * > jQuery|String el       : Child element to search form elements in, being the element or a selector.
         *
         * @returns Array of { name : value }, works wkl with $.param()
         */
        _getFormValues: function(options) {
            var values = [];
            var onlySubmittable = (options && options.onlySubmittable);
            var $el = this.$el;
            if (options && options.el) {
                $el = this.$( options.el );
            }

            $el.find('input, select, textarea').each(function() {
                if (!this.name) {
                    return;
                }

                var $input = $(this);
                if (onlySubmittable && $input.is(':disabled')) {
                    return;
                }
                if (($input.is(':radio') || $input.is(':checkbox')) && !$input.prop('checked')) {
                    return;
                }

                values.push({
                    name : this.name,
                    value: $input.val()
                });
            });
            
            return values;
        },

        _getFormValuesAsObject: function(options) {
            var values = {};

            _.each(this._getFormValues(options), function(formValue) {
                values[formValue.name] = formValue.value;
            });

            return values;
        },

        /**
         * Render the view's template w/ data.
         *
         * @param Object data (optional)
         * @param Object partials (optional) Map of partials, { name: 'id' }
         * @param Object options (optional) List of options for template rendering
         */
        renderTemplate: function(data, partials, options) {
            this._renderTemplate(this.templateId, data, partials, options);
        },

        /**
         * Render the template with data.
         *
         * @param String templateId DOM <script> id
         * @param Object data(optional)
         * @param Object partials (optional) Map of partials, { name: 'id' }
         * @param Object options (optional) List of options for template rendering
         *   > bool replace (default: false) Should the template replace current $el, not be appended to it?
         */
        _renderTemplate: function(templateId, data, partials, options) {
            var template = $('#' + templateId).html();

            if (partials) {
                $.each(partials, function(name, id) {
                    partials[name] = $('#' + id).html();
                });
            }

            var html = Mustache.render(template, data, partials);

            if (options && options.replace) {
                this.setElement(html);
            } else {
                this.$el.html(html);
            }

            // Re-populate the UI elements
            this._populateUi();
        }

    });
});
